export default __webpack_public_path__ + "static/media/1.819e6a8a.png";